import $ from "jquery";

const closeBasket = function () {
    $(".v2-basket").removeClass("is-open");
    $("body").removeClass("mobile-popup-open");
};

export default closeBasket;